import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineSwitchOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M3.275 8v5.775c0 .58.47 1.05 1.05 1.05H10.1c.58 0 1.05-.47 1.05-1.05V8l2.076-5.398a1.05 1.05 0 0 0-.98-1.427H7.342a2.1 2.1 0 0 0-1.96 1.346z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M3.275 8V1.175H8"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.3}
      d="M8.525 11.413a1.312 1.312 0 1 0-2.625 0 1.312 1.312 0 0 0 2.625 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M9.293 3.275 8.283 5.9"
    />
  </svg>
);
export default SvgStreamlineSwitchOff;
